import React from 'react'
import PropTypes from 'prop-types'

import { StyledBlock } from './BlockMedia.styled'
import NormalizeMedia from '../../utils/NormalizeMedia'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'

const BlockMedia = ({ className, media }) => {
  const isMobile = useMediaQuery(deviceMax.mobileL)
  return (
    <StyledBlock className={className}>
      {NormalizeMedia(media, isMobile)}
    </StyledBlock>
  )
}

BlockMedia.propTypes = {
  className: PropTypes.string,
  media: PropTypes.object.isRequired,
}

export default BlockMedia
